<template>
  <AsideGabarit :title="$t('filters.idealLocation')" :action="action">
    <ToggleFilter :caption="$t('idealArea')" :icon="'info'" :override-active="isochroneDisplay" :action="() => toggleIsochrone()" />

    <div class="range-slider">
      <input id="myRange" v-model="range" type="range" min="10" max="550" step="1" class="slider" />
      <input v-model="range" type="number" />
    </div>
    <button @click="upadteMode">Switch mode</button>
    <div class="">
      {{ isochroneMode }}
    </div>
  </AsideGabarit>
</template>

<script>
import { mapGetters } from 'vuex';
import AsideGabarit from './AsideGabarit';
import ToggleFilter from './ToggleFilter';
export default {
  components: {
    AsideGabarit,
    ToggleFilter,
  },

  props: ['action'],

  data() {
    return {
      range: 100,
    };
  },

  computed: {
    ...mapGetters({
      isochrone: 'isochrone',
      isochroneMode: 'isochroneMode',
      isochroneDisplay: 'isochroneDisplay',
    }),
  },

  watch: {
    range(newVal) {
      this.$store.dispatch('updateIsochroneDecay', parseFloat(newVal / 100));
    },
  },

  created() {
    const id = this.$route.params.studyId;
    if (!this.isochrone) {
      this.$store.dispatch('getIsochrone', { id, payload: {}, isPrivate: false });
      this.$store.dispatch('getIsochrone', { id, payload: {}, isPrivate: true });
    }
  },

  methods: {
    toggleIsochrone() {
      this.$store.dispatch('updateIsochroneDisplay', !this.isochroneDisplay);
    },

    upadteMode() {
      const mode = this.isochroneMode === 'public' ? 'private' : 'public';
      this.$store.dispatch('updateIsochroneMode', { mode });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.range-slider {
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
</style>
